<template>
  <a-select class="my-select" :value="props.modelValue" @update:value="emits('update:modelValue', $event)" :options="option?option:props.options" allowClear>
    <slot></slot>
  </a-select>
</template>

<script setup>
import {ref, defineProps, defineEmits, defineExpose, watchEffect, onMounted, watch, useAttrs} from 'vue';
  const props = defineProps({
    modelValue: {},
    url: {
      type: [Function], 
    },
    params: {
      type: [Object],
      default: () => ({})
    },
    onSetOptions: {
      type: [Function],
    },
    options: {
      type: [Array],
      default: () => []
    },
    show: {
      type: [Boolean],
      default: true,
    },
    onGetFormData: {
      type: [Function],
    }
  });
  const emits = defineEmits(['update:modelValue']);
  const option = ref(false);
  const attrs = useAttrs();
  const init = (fun = props.url, params = props.params) => {
    fun(params).then(res => {
      if (props.onSetOptions) {
        option.value = props.onSetOptions(res);
      } else {
        option.value = res.data.records ? res.data.records : res.data;
      }
      if (!!props.modelValue && !attrs.hasOwnProperty('show-search') && !option.value.some(res => res[attrs.fieldNames?.value || 'value'] === props.modelValue)) {
        const formData = props.onGetFormData();
        option.value = [
          {
            [attrs.fieldNames?.value || 'value']: props.modelValue,
            [attrs.fieldNames?.label || 'label']: formData[attrs.fieldNames?.label || 'label'],
            disabled: true
          },
          ...option.value
        ];
      }
    })
  };

  const setOption = (options) => {
    option.value = options;
  }

  watch([() => props.url, () => props.show], (v) => {
    props.show && props.url && init(props.url, props.params);
  }, { immediate: true })

  defineExpose({
    init,
    setOption,
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-select{
    min-width: 200px;
  }
</style>
